<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="watch-video-list">
      <Title :jpn="t('動画を見てコインを獲得')" />
      <div class="video_area" v-for="(video, index) in dispWatchVideoList" :key="video.id">
        <div class="video-container">
          <video ref="videoPlayer" @ended="handleVideoEnd" playsinline :poster="video.thumbnail || null">
            <source :src="video.thumbnail ? video.url : `${video.url}#t=0.1`" :type="getMimeType(video.url)">
          </video>
          <button v-if="!isPlaying" class="play-button" @click="playVideo(index, video.id)">▶</button>
          <div class="watched" v-if="video.is_watched"><span>{{ t('視聴済み') }}</span></div>
          <div class="get-coin">
            <img src="/img/star_coin_version1.webp" class="coin" />
            <div class="point">{{ video.point | comma }} </div>
          </div>
        </div>
        <div class="profile-card-wrapper">
          <a class="profile-card" :href="video.link" target="_blank">
            <div class="profile-icon">
              <img :src="video.icon" alt="User Icon" onerror="this.style.display='none'; this.parentElement.classList.add('no-image');">
            </div>
            <span class="profile-name">{{ video.company_name }}</span>
            <span class="profile-arrow">›</span>
          </a>
          <div class="video-name">
            <span>{{ video.video_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      watchVideoList: 'watchVideo/watchVideoList',
      watchVideoResult: 'watchVideo/watchVideoResult',
    }),
    dispWatchVideoList() {
      if (this.watchVideoList) {
        if (this.watchVideoList.list.length > 0) {
          console.log(this.watchVideoList.list);
          return this.watchVideoList.list;
        }
      }
      return [];
    },
  },

  watch: {
    watchVideoResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('watchVideo/clearWatchVideo');
          this.$store.dispatch('watchVideo/setWatchVideoList');
          this.$store.dispatch('user/setCurrentUser');
        } else {
          const { watch_video: watchVideo } = newVal.errors;
          alert(watchVideo[0]);
        }
      }
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  components: {
    BaseTemplate,
    Title,
  },

  data: () => ({
    isPlaying: false,
    videoID: 0,
  }),

  created() {
    this.$store.dispatch('watchVideo/clearWatchVideoList');
    this.$store.dispatch('watchVideo/setWatchVideoList');
  },

  methods: {
    playVideo(index, id) {
      const video = this.$refs.videoPlayer[index];
      if (video) {
        this.videoID = id;
        video.play();
        this.isPlaying = true;
      } else {
        console.error('Video element not found');
      }
    },
    handleVideoEnd() {
      this.isPlaying = false;
      this.$store.dispatch('watchVideo/setWatchVideo', { id: this.videoID });
    },
    getMimeType(url) {
      const extension = url.split('.').pop().toLowerCase();
      switch (extension) {
        case 'mp4':
          return 'video/mp4';
        case 'webm':
          return 'video/webm';
        case 'ogg':
        case 'ogv':
          return 'video/ogg';
        default:
          return 'video/mp4'; // デフォルト
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.watch-video-list {
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 90px;
  margin: 0px auto;
}
.video_area{
  position: relative;
  margin: 10px 0 40px 0;
  .video-container {
    position: relative;
    width: 100%;
    border-radius: 30px;
    // box-shadow: 5px 5px 10px rgba(0, 0, 0, 1);
    .get-coin{
      position: absolute;
      z-index: 1;
      bottom: 3%;
      right: 2%;
      width: fit-content;
      display: flex;
      align-items: center;
      padding: 5px;
      background-color: #898989;
      border-radius: 5px;
      img{
        width: 50px;
        height: fit-content;
      }
      .point{
        font-size: 22px;
        font-weight: bold;
        color: $white;
      }
    }
    video {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 30px;
      aspect-ratio: 16 / 9;
    }
  }
}
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 24px;
  cursor: pointer;
}
.play-button:hover {
  background: rgba(0, 0, 0, 0.9);
}

.watched {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-size: 80px;
  border-radius: 8px;
  border-radius: 30px;
  span{
    border-radius: 8px;
    padding: 5px 20px;
    font-weight: bold;
    transform: rotate(15deg);
    text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
  }
}
$card-bg: #f5f5f5;
$icon-bg: #d8d8d8;

.profile-card-wrapper {
  display: flex;
  // align-items: flex-start;
  align-items: center;
  margin-top: 20px;
  .profile-card {
    display: flex;
    justify-content: space-between;
    max-width: 35%;
    min-width: 35%;
    align-items: center;
    background: $card-bg;
    border-radius: 25px;
    padding: 8px 15px;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);
    border: 1px solid #ccc;
    margin-right: 10px;
    cursor: pointer;
    .profile-icon {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: $icon-bg;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.no-image {
        background: $icon-bg; // 画像がない場合の背景色
      }
    }
    .profile-name {
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }
    .profile-arrow {
      color: #666;
      font-size: 18px;
    }
  }
  .video-name {
    color: #001f87;
    word-break: break-word;
  }
}

@media screen and (max-width: $tabletWidth) {
  .video_area{
    .video-container {
      .get-coin{
        bottom: 7%;
        right: 4%;
        img {
          width: 25px;
          height: 25px;
        }
        .point {
          font-size: 12px;
        }
      }
    }
  }
  .watched {
    font-size: 40px;
  }
  .profile-card-wrapper {
    margin-top: 10px;
    .profile-card {
      padding: 4px 7px;
      max-width: 45%;
      min-width: 45%;
      .profile-icon {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
      .profile-name {
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .video-name {
      font-size: 10px;
    }
  }
}
</style>
